import React from 'react';
import { Input } from 'antd';

interface TextareaProps {
  id: string;
  placeholder: string;
  isDisabled?: boolean;
}

export const Textarea: React.FC<TextareaProps> = ({
  id,
  placeholder,
  isDisabled,
}) => (
  <Input.TextArea
    id={id}
    autoSize={{ minRows: 5, maxRows: 10 }}
    placeholder={placeholder}
    disabled={isDisabled}
  />
);
